export const LayerNameUtil = {
  Satellite: "Satellite",
  Street: "Street",
};
